export default __webpack_public_path__ + "static/media/pantry2-after1-2048w.b9b05139.avif";